"use strict";
const snjs = require('@standardnotes/snjs');
module.exports = snjs;
